import { S3_BUCKET_URL } from '@/constants';

import { ScreenAboutLook } from './screens/AboutLook';
import {
  BODY_SHAPE_OPTIONS_FEMALE,
  BODY_SHAPE_OPTIONS_MALE,
  ScreenBodyShape,
} from './screens/BodyShape';
import { ScreenChatPreview } from './screens/ChatPreview';
import { ScreenCommunicate } from './screens/Communicate';
import { ScreenEmail } from './screens/Email';
import { ScreenForestIntro } from './screens/ForestIntro';
import { GENDER_OPTIONS, ScreenGender } from './screens/Gender';
import { ScreenIllness } from './screens/Illness';
import { ScreenInteraction } from './screens/Interaction';
import { ScreenName } from './screens/Name';
import { ScreenObedience } from './screens/Obedience';
import { ScreenSecurity } from './screens/Security';
import { ScreenSettingUpProfile } from './screens/SettingUpProfile';
import { LayoutDataType } from './types';

const LAYOUT_PATH = `${S3_BUCKET_URL}/layout-own-ai-multigender-forest`;
const PAYWALL_PATH = `${S3_BUCKET_URL}/paywall/forest`;

export const layoutSteps = {
  gender: {
    component: ScreenGender,
    images: GENDER_OPTIONS.map(
      (o) => `${LAYOUT_PATH}/gender/forest-${o.id}.jpg`,
    ),
  },
  about_look: {
    component: ScreenAboutLook,
    images: GENDER_OPTIONS.map((o) => `${LAYOUT_PATH}/about-look/${o.id}.png`),
  },
  body_shape: {
    component: ScreenBodyShape,
    images: [
      ...BODY_SHAPE_OPTIONS_FEMALE.map(
        (o) => `${LAYOUT_PATH}/body-shape/female/${o.id}.png`,
      ),
      ...BODY_SHAPE_OPTIONS_MALE.map(
        (o) => `${LAYOUT_PATH}/body-shape/male/${o.id}.png`,
      ),
    ],
  },
  obedience: {
    component: ScreenObedience,
    images: [],
  },
  illness: {
    component: ScreenIllness,
    images: [],
  },
  name: {
    component: ScreenName,
    images: [],
  },
  forest_intro: {
    component: ScreenForestIntro,
    images: GENDER_OPTIONS.map(
      (o) => `${LAYOUT_PATH}/forest-intro/${o.id}.jpg`,
    ),
  },
  interaction: {
    component: ScreenInteraction,
    images: [],
  },
  communicate: {
    component: ScreenCommunicate,
    images: [],
  },
  chat_preview: {
    component: ScreenChatPreview,
    images: [
      `${LAYOUT_PATH}/chat-preview/glowing.png`,
      ...BODY_SHAPE_OPTIONS_FEMALE.map(
        (o) => `${PAYWALL_PATH}/female/${o.id}.png`,
      ),
      ...BODY_SHAPE_OPTIONS_MALE.map((o) => `${PAYWALL_PATH}/male/${o.id}.png`),
    ],
  },
  email: {
    component: ScreenEmail,
    images: GENDER_OPTIONS.map((o) => `${LAYOUT_PATH}/email/${o.id}.jpg`),
  },
  security: {
    component: ScreenSecurity,
    images: [],
  },
  setting_up_profile: {
    component: ScreenSettingUpProfile,
    images: [],
  },
};

export const layoutStepsKeys = Object.keys(layoutSteps);

export const layoutDataDefault: LayoutDataType = {
  gender: null,
  about_look: null,
  body_shape: null,
  obedience: null,
  illness: null,
  interaction: null,
  communicate: null,
  name: '',
  email: '',
};
